'use client'

import { useEffect, useState } from 'react'

/** Пауза перед запросом: продавец печатает, и на каждую букву в справочник ходить незачем. */
const typingPause = 250

type State<Option> = {
  query: string
  options: Option[]
  isFailed: boolean
}

/**
 * Поиск по справочнику с паузой на ввод. Ответ хранится вместе со строкой запроса, на который
 * он пришёл, поэтому список всегда отвечает последнему, что набрал продавец.
 */
export const useDirectorySearch = <Option>(query: string, search: (query: string) => Promise<Option[]>) => {
  const [state, setState] = useState<State<Option>>({ query: '', options: [], isFailed: false })
  const normalizedQuery = query.trim()

  useEffect(() => {
    if (!normalizedQuery) {
      return
    }

    let isActive = true
    const timer = window.setTimeout(() => {
      search(normalizedQuery)
        .then((options) => isActive && setState({ query: normalizedQuery, options, isFailed: false }))
        .catch(() => isActive && setState({ query: normalizedQuery, options: [], isFailed: true }))
    }, typingPause)

    return () => {
      isActive = false
      window.clearTimeout(timer)
    }
    // Функция поиска создаётся заново на каждый рендер, поэтому следим только за строкой запроса.
  }, [normalizedQuery])

  const isCurrent = Boolean(normalizedQuery) && state.query === normalizedQuery

  return { options: isCurrent ? state.options : [], isFailed: isCurrent && state.isFailed }
}
